import store from "../../../store";
import { ModuleTypes } from "@/store/ModuleTypes";
import { SnackbarMutationTypes } from "@/views/academy/common/snackbar/SnackbarMutationTypes";
import { i18n } from "@/plugins/i18n";
import Router from "@/router/index";
import { ACADEMY_PREFIX } from "@/router/Routes";

export const handleApiError = (err: any) => {
  let errorCode;
  switch (err?.response?.status) {
    case 401:
      errorCode = i18n.tc("api_error_message.unauthorized_access");
      break;
    case 403:
      errorCode = i18n.tc("api_error_message.forbidden");
      Router.push(`${ACADEMY_PREFIX}`);
      break;
    case 412:
      errorCode =
        err.response?.data?.data?.registrationPlayerRequestForm ||
        err.response?.data?.message;
      break;
    case 404:
    case 418:
    case 500:
      errorCode = err?.response?.data?.message;
      break;
    default:
      errorCode = i18n.tc("common.error");
  }
  store.dispatch(
    `${ModuleTypes.SNACKBAR}/${SnackbarMutationTypes.SHOW_SNACKBAR}`,
    { text: errorCode, timeout: 10000 }
  );
};
